import { render } from "./PatientInfoTab.vue?vue&type=template&id=c30a2146&scoped=true"
import script from "./PatientInfoTab.vue?vue&type=script&lang=js"
export * from "./PatientInfoTab.vue?vue&type=script&lang=js"

import "./PatientInfoTab.vue?vue&type=style&index=0&id=c30a2146&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c30a2146"]])

export default __exports__